
/**
 * Removes query parameters, trailing slashes, and path parameters from a URL
 * @param {string} url - The URL to process
 * @returns {string} - The cleaned URL
 */
export function qkeyFromUrl(url) {
  // Remove query parameters (everything after and including '?')
  const withoutParams = url.split('?')[0];
  
  // Remove trailing slash if present
  const withoutTrailingSlash = withoutParams.endsWith('/') ? withoutParams.slice(0, -1) : withoutParams;
  
  // Remove path parameters (handles cases like /posts/{id})
  return withoutTrailingSlash.replace(/\/\{[^}]+\}$/, '');
}